import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Wordmark, th, T, F, Btn } from "@/lib/bricks";

// Where a deal-room reminder's "Stop these reminders" link lands. It asks before it acts,
// so a mail scanner that opens the link doesn't turn anyone's reminders off.

const p = th(false);

export default function RemindersStopPage() {
  const { token } = useParams();
  const BASE = process.env.REACT_APP_BACKEND_URL;
  const [state, setState] = useState("ask"); // ask | busy | done | error

  useEffect(() => {
    const prevBg = document.body.style.background;
    const prevTitle = document.title;
    document.body.style.background = p.bg;
    document.title = "Reminders · Bricks";
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow"; document.head.appendChild(m);
    return () => { document.body.style.background = prevBg; document.title = prevTitle; m.remove(); };
  }, []);

  const stop = async () => {
    setState("busy");
    try {
      const r = await fetch(`${BASE}/api/public/reminders/stop/${encodeURIComponent(token)}`, { method: "POST", cache: "no-store", credentials: "omit" });
      if (!r.ok) throw new Error();
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <div data-testid="reminders-stop-page" style={{ minHeight: "100vh", background: p.bg, color: p.ink, fontFamily: F.display, display: "flex", flexDirection: "column", overflowX: "clip" }}>
      <header style={{ borderBottom: `1px solid ${p.hair}` }}>
        <div style={{ maxWidth: 1120, margin: "0 auto", padding: "0 clamp(20px, 4vw, 40px)", height: 72, display: "flex", alignItems: "center" }}>
          <a href="https://www.brxs.ca" aria-label="Bricks" rel="noreferrer" style={{ display: "inline-flex", minHeight: 44, alignItems: "center" }}>
            <Wordmark size={20} color={T.ink} />
          </a>
        </div>
      </header>
      <main style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "48px 20px" }}>
        <div style={{ maxWidth: 440, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
          {state === "done" ? (
            <>
              <h1 data-testid="reminders-stopped" style={{ margin: 0, fontSize: 24, fontWeight: 500, letterSpacing: "-0.01em" }}>Reminders are off</h1>
              <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: p.ink3 }}>You won't get any more reminder emails for this deal. You can turn them back on from the page your agent shared with you.</p>
            </>
          ) : (
            <>
              <h1 style={{ margin: 0, fontSize: 24, fontWeight: 500, letterSpacing: "-0.01em" }}>Stop deadline reminders?</h1>
              <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: p.ink3 }}>You'll stop getting reminder emails for this deal. Nothing else changes.</p>
              {state === "error" ? <div role="alert" style={{ fontSize: 13, color: T.brickDeep }}>That didn't go through. Try again.</div> : null}
              <Btn variant="primary" onClick={stop} disabled={state === "busy"} data-testid="reminders-stop">{state === "busy" ? "Stopping…" : "Stop reminders"}</Btn>
            </>
          )}
        </div>
      </main>
      <footer style={{ borderTop: `1px solid ${p.hair}` }}>
        <div style={{ maxWidth: 1120, margin: "0 auto", padding: "20px clamp(20px, 4vw, 40px)", minHeight: 72, boxSizing: "border-box", display: "flex", alignItems: "center", fontSize: 13, color: p.ink3 }}>Sent through Bricks</div>
      </footer>
    </div>
  );
}
